export function serializeRegistrationForm(fields) {
  const params = new URLSearchParams({
    name: String(fields.name),
    email: String(fields.email),
    sign_agree: String(fields.sign_agree),
    ip: String(fields.ip),
    pid: String(fields.pid),
    pid_sid: String(fields.pid_sid)
  });
  return params.toString();
}
